



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// import { State, Action, Getter } from 'vuex-class';
import VueApexCharts from "vue-apexcharts";
import thinBar from "@/data/thin-bar-graph";
import thinDonutGender from "@/data/thin-donut-gender-chart";

@Component({
  components: {
    VueApexCharts,
  },
})
export default class StatChartCard extends Vue {
  @Prop({ default: "Completed Consents" }) title!: string;
  @Prop({ default: 30 }) count!: number;
  @Prop({ default: 100 }) total!: number;

  thinDonut: any = thinDonutGender;
  seriesData!: any;
  optionsData!: any;

  get lineSeriesData() {
    return this.seriesData || this.thinDonut.series;
  }

  get lineOptionsData() {
    return this.optionsData || this.thinDonut.options;
  }
}
